module.exports = __webpack_public_path__ + "img/whatsapp.37acdd6e.png";